import { Component, inject, input } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ServicePortalApi } from '../../../api/api';
import { Role } from '../../../api/types';
import { SynButtonComponent, SynIconComponent } from '@synergy-design-system/angular';
import { ColumnDescription, TableComponent } from '../../components/table';

@Component({
  selector: 'app-client-roles',
  template: `
    <div class="flex-row gap-2 align-center margin-bottom-1" style="padding-right: 5px;">
      <p i18n="@@client-roles-description">
        These roles can be assigned to users of your application.
        If a user logs into your client, their roles for that client are
        automatically mapped into the user's token.
      </p>
      @if (canManageRoles()) {
        <syn-button [routerLink]="['/', 'clients', id, 'roles', 'new']"
                    data-e2e="btn-add-role">
          <syn-icon name="add_fill" slot="prefix" />
          <span i18n="@@add-role">Add Role</span>
        </syn-button>
      }
    </div>

    <div style="padding-right: 5px;">
      <app-table
        [columns]="columns"
        [values]="roles()"
        [clickable]="true"
        (selectValue)="onSelectRole($event)"
      />
    </div>
  `,
  styles: [
    `
    `,
  ],
  imports: [
    SynButtonComponent,
    SynIconComponent,
    TableComponent,
    RouterLink,
  ],
})
export class ClientRolesComponent {
  id = inject(ActivatedRoute).snapshot.params['id'];
  api = inject(ServicePortalApi);
  router = inject(Router);

  roles = input.required<Role[]>();

  canManageRoles = input.required<boolean>();

  columns: ColumnDescription<Role>[] = [
    {
      label: $localize`:@@name:Name`,
      getField: (role) => {
        if (role.name == 'client_admin') {
          return role.name + ' (Only used in old serviceportal)';
        } else {
          return role.name;
        }
      },
      style: 'width: 30%',
    },
    {
      label: $localize`:@@description:Description`,
      getField: (role) => role.description,
      style: 'width: 40%',
    },
    {
      label: $localize`:@@public:Public`,
      getField: (role) => role.isPublic ? '✔' : '✖',
      style: 'width: 15%',
    },
    {
      label: $localize`:@@members:Members`,
      getField: (role) => role.memberCount.toString(),
      style: 'width: 15%',
    },
  ];

  onSelectRole(role: Role) {
    void this.router.navigate(['clients', this.id, 'roles', role.id]).then(() => {
    });
  }
}
